import { types, Instance } from 'mobx-state-tree';
const { model, string, identifier, array, maybe, number, maybeNull } = types;

/*export const LDAPDepartmentModel = model('LDAPDepartmentModel', {
  //ou: string,
  ou: identifier,
  dn: string,
  description: string,
  objectClass: array(string),
});*/

export const LDAPDepartmentModel = model('LDAPDepartmentModel', {
  dn: identifier,
  base: string,
  ou: maybe(string),
  o: maybe(string),
  description: maybe(string),
  facsimiletelephonenumber: maybe(string),
  l: maybe(string),
  co: maybe(string),
  labeleduri: maybe(string),
  manager: maybe(string),
  objectсlass: array(string),
  postaladdress: maybe(string),
  st: maybe(string),
  telephonenumber: maybe(string),
  memberuid: maybe(array(string)),
  createtimestamp: maybeNull(string),
  modifytimestamp: maybeNull(string),
  orgId: maybe(string),
  reSyncProvider: array(string),
  githubOrgId: maybe(string),
  end_date: maybeNull(string),
  managers: array(string),
  managersData: maybe(array(types.frozen())),
  department_id: maybeNull(number),
});

export type ILDAPDepartmentModel = Instance<typeof LDAPDepartmentModel>;

/* 
{
  "objectclass": [
      "organizationalUnit",
      "top",
      "gosaDepartment"
  ],
  "co": "country",
  "dn": "ou=department4newnew,ou=department3,ou=department2,ou=department1,dc=company2,dc=webuserid,dc=com",
  "base": "/department4newnew/department3/department2/department1",
  "ou": "department4newnew",
  "description": "department4 NEW",
  labeleduri: "url",
  "st": "qwe",
  "l": "qwe",
  "postaladdress": "qwe",
  "telephonenumber": "123",
  "facsimiletelephonenumber": "123",
  "manager": "uid=test2test2,ou=people,dc=example,dc=com"
}
*/
